import { createShiftJsonClient } from '../http/shift-json-client';
import type { ShiftHomeDashboard, ShiftManagerAnnouncement } from '../../models/home.types';

const requestJson = createShiftJsonClient('אין תקשורת לשרת. ודאו שה-backend פועל.');
const requestDashboard = createShiftJsonClient(
  'אין תקשורת לשרת. ודאו שה-backend רץ על http://localhost:5000.',
  false,
);

class ShiftHomeService {
  async getDashboard(): Promise<ShiftHomeDashboard> {
    return requestDashboard<ShiftHomeDashboard>('/shift/home/dashboard', { method: 'GET' });
  }

  async getManagerAnnouncement(): Promise<ShiftManagerAnnouncement> {
    return requestJson<ShiftManagerAnnouncement>('/shift/home/manager-announcement');
  }

  async updateManagerAnnouncement(announcement: string): Promise<ShiftManagerAnnouncement> {
    return requestJson<ShiftManagerAnnouncement>('/shift/home/manager-announcement', {
      method: 'PATCH',
      body: JSON.stringify({ announcement }),
    });
  }
}

export const shiftHomeService = new ShiftHomeService();
